export type GetRoute = {
  [key in RouteKeys]: string
}

export type RouteKeys =
  | 'about'
  | 'ancienneBelgique'
  | 'becomeProducer'
  | 'becomeProducerForm'
  | 'benefitsAtWork'
  | 'boltXPlenty'
  | 'blog'
  | 'blogArticle'
  | 'boltDriveFlex'
  | 'boltFixOptIn'
  | 'brusselsAirport'
  | 'careerDetail'
  | 'careers'
  | 'complaint'
  | 'dynamicPricing'
  | 'encyclopedia'
  | 'encyclopediaArticle'
  | 'encyclopediaCategory'
  | 'energyCrisisFaq'
  | 'faq'
  | 'festivals'
  | 'home'
  | 'injectionTariff'
  | 'instalmentConfirmation'
  | 'instalmentOptOut'
  | 'move'
  | 'moveLP'
  | 'noEan'
  | 'oldTerms'
  | 'pluspas'
  | 'priceList'
  | 'pricing'
  | 'privacy'
  | 'producerInfo'
  | 'producers'
  | 'projectDetail'
  | 'projects'
  | 'referral'
  | 'registration'
  | 'registrationLoading'
  | 'settlement'
  | 'simulation'
  | 'springCampaign'
  | 'terms'
  | 'uspsCustomerCare'
  | 'uspsFairPrice'
  | 'uspsFun'
  | 'uspsLocal'
  | 'uspsOverview'
  | 'productDetail'

export enum RouteVariables {
  ARTICLE = ':article',
  CATEGORY = ':category',
  SLUG = ':slug',
  VERSION = ':version'
}
